import anime from 'animejs';

// close mobile nav
const navClose = anime({
  targets: '.nav-mobile',
  translateY: '-150vh',
  easing: 'easeOutCubic',
  autoplay: false,
  duration: 200,
  begin: function () {
    $('.btn-nav-mobile-toggle .inner-text').html('Menu');
  },
  complete: function () {
    $('body').removeClass('is-fixed');
    $('.btn-nav-mobile-toggle').removeClass('open').addClass('close');
    $('.nav-mobile').css('opacity', '0');
  }
});

// hamburger icon animates into X
const iconClose = anime.timeline({
  easing: 'easeOutCubic',
  duration: 150,
  autoplay: false,
});

iconClose.add({
  targets: '.icon-menu .bar-mid',
  scaleX: 0,
  duration: 50,
}, '-=100')
.add({
  targets: '.icon-menu .bar-top, .icon-menu .bar-bot',
  y: 4,
}, 0)
.add({
  targets: '.icon-menu .bar-top',
  transformOrigin: '50% 50% 0',
  rotate: 45,
}, 0)
.add({
  targets: '.icon-menu .bar-bot',
  transformOrigin: '50% 50% 0',
  rotate: -45,
}, 0);

// open mobile nav
const navOpen = anime({
  targets: '.nav-mobile',
  translateY: ['-200vh', '0'],
  easing: 'easeOutCubic',
  autoplay: false,
  duration: 200,
  begin: function () {
    $('.nav-mobile').css('opacity', '1');
    $('.btn-nav-mobile-toggle .inner-text').html('Close');

  },
  complete: function () {
    $('body').addClass('is-fixed');
    $('.btn-nav-mobile-toggle').removeClass('close').addClass('open');
  }
});

// X icon animaties into hamburger
const iconOpen = anime.timeline({
  easing: 'easeOutCubic',
  duration: 150,
  autoplay: false,
});

iconOpen.add({
  targets: '.icon-menu .bar-top',
  transformOrigin: '50% 50% 0',
  rotate: 0,
}, 0)
.add({
  targets: '.icon-menu .bar-bot',
  transformOrigin: '50% 50% 0',
  rotate: 0,
}, 0)
.add({
  targets: '.icon-menu .bar-mid',
  scaleX: 100,
  duration: 50,
}, '-=100')
.add({
  targets: '.icon-menu .bar-top',
  y: 0,
}, 0)
.add({
  targets: '.icon-menu .bar-bot',
  y: 8,
}, 0);

// called from _resize.js + _orientation.js
export const resizeNavMobile = () => {
  const winHeight = document.documentElement.clientHeight;
  const globalHeader = $('.global-header').height();
  const siteHeader = $('.site-header').height();
  const navheight = winHeight - (globalHeader + siteHeader);

  $('.nav-mobile').css('height', `${navheight}px`);
}

$(document).on('click', '.btn-nav-mobile-toggle.close', () => {
  resizeNavMobile();
  iconClose.play();
  navOpen.play();
});

$(document).on('click', '.btn-nav-mobile-toggle.open', () => {
  iconOpen.play();
  navClose.play();
})

$(document).ready(function() {
  $(document.body).on(
    'click',
    '.nav-mobile__item.nav-mobile__item_has_child > .nav-mobile__link',
    e => {
      e.preventDefault();

      console.log('hi');

      const target = e.currentTarget;
      const $target = $(target);
      const $parent = $($target.parent().get(0));
      const opened = $parent.hasClass('opened');

      $parent.toggleClass('opened');
      $target.attr('aria-expanded', (_, attr) => {
        if (attr === 'false') {
          return 'true';
        }
        return 'false';
      });
      if (!opened) {
        // $parent.siblings().removeClass('opened');
        $target
          .parent()
          .siblings()
          .find('.nav__link[aria-haspopup="true"]')
          .attr('aria-expanded', 'false');
      }
    }
  );
  $('a.st-ui-close-button.st-search-hide-outputs').on('click', function () {
    $('.st-ui-overlay.st-search-hide-outputs').click();
  })
});
